export const MainContentDummy = [
  {
    src: "https://img1.daumcdn.net/thumb/C1200x900/?scode=mtistory2&fname=http%3A%2F%2Fcfile10.uf.tistory.com%2Fimage%2F99A81B3C5BB2C6EF2C9883",
    MoveToPage: "https://hotel990.com/",
  },
  {
    src: "https://img1.daumcdn.net/thumb/C1200x900/?scode=mtistory2&fname=https%3A%2F%2Ft1.daumcdn.net%2Ftistory_admin%2Fassets%2Fpromotions%2F72a26c24396048fa9fb668442021a18b",
    MoveToPage: "https://leeheehoon.tistory.com/",
  },
  {
    src: "https://img1.daumcdn.net/thumb/C1200x900/?scode=mtistory2&fname=http%3A%2F%2Fcfile2.uf.tistory.com%2Fimage%2F99D6CF405BB2C6B824A969",
    MoveToPage: "https://hygphoto.tistory.com/",
  },
  {
    src: "https://img1.daumcdn.net/thumb/C1200x900/?scode=mtistory2&fname=http%3A%2F%2Fcfile1.uf.tistory.com%2Fimage%2F99368F335BB2C64F29335D",
    MoveToPage: "https://so-oh.tistory.com/category",
  },
];

export const MainContentsponsorDummy = [
  {
    src: "https://img1.daumcdn.net/thumb/R300x100/?scode=mtistory2&fname=http%3A%2F%2Fcfile27.uf.tistory.com%2Fimage%2F99A6963C5BB2C5C32AB7FC",
    MoveToPage: "https://thehyundaiblog.com/",
  },
  {
    src: "https://img1.daumcdn.net/thumb/R300x100/?scode=mtistory2&fname=http%3A%2F%2Fcfile27.uf.tistory.com%2Fimage%2F9989ED3B5BB2C5D3287867",
    MoveToPage: "https://blogdegalleria.tistory.com/",
  },
  {
    src: "https://img1.daumcdn.net/thumb/R300x100/?scode=mtistory2&fname=http%3A%2F%2Fcfile29.uf.tistory.com%2Fimage%2F9988F0395BB2C5B11F8B83",
    MoveToPage: "https://blog.paradise.co.kr/",
  },
  {
    src: "https://img1.daumcdn.net/thumb/R300x100/?scode=mtistory2&fname=http%3A%2F%2Fcfile23.uf.tistory.com%2Fimage%2F991B033C5BB2C59024121E",
    MoveToPage: "https://www.witheverland.com/",
  },
  {
    src: "https://img1.daumcdn.net/thumb/R300x100/?scode=mtistory2&fname=http%3A%2F%2Fcfile24.uf.tistory.com%2Fimage%2F9950223C5BB2C57B2225FF",
    MoveToPage: "https://www.witheverland.com/",
  },
];
